"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AwardWithBackground = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const AwardWithBackgroundSVG_1 = require("./AwardWithBackgroundSVG");
const Award_1 = require("../Award/Award");
const utils_1 = require("../../../../helpers/utils");
const AwardColors_1 = require("../config/AwardColors");
const AwardWithBackground = ({ color = 'default', award }) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: "img-section", style: { backgroundColor: AwardColors_1.COLORS[color].darkColor }, children: (0, jsx_runtime_1.jsxs)("div", { className: "p-0 img-content-wrapper", "aria-label": __.trans('aria.award'), role: "img", children: [(0, jsx_runtime_1.jsx)(AwardWithBackgroundSVG_1.AwardWithBackgroundSVG, { darkColor: AwardColors_1.COLORS[color].darkColor, lightColor: '#F7F7F7' }), (0, jsx_runtime_1.jsx)(Award_1.Award, { award: award, color: (0, utils_1.getAwardColor)(award), className: "img-content-medal", ariaHidden: true })] }) }));
};
exports.AwardWithBackground = AwardWithBackground;
